import React from "react";
import { DialogProps } from "@material-ui/core/Dialog";
import locale from "@bonliva-crm/locale";
import { ConfirmDialogAction } from "./utils";

export class ConfirmDialogOptions<T> {
  title: React.ReactNode = locale.AreYouSure;

  message: React.ReactNode;

  actions: Array<ConfirmDialogAction<T>> = [];

  dialogProps: Partial<DialogProps> = {
    PaperProps: {
      style: { width: "30rem" }
    }
  };
}
